export default __webpack_public_path__ + "short-quotes-section.png";